module.exports = __webpack_public_path__ + "media/bg4.a0a54461.webm";